export default __webpack_public_path__ + "static/media/login-min.0ff629c8.jpg";